// @flow

import React, { PureComponent } from 'react'
import styles from './index.css'
import type { Historie } from '../domain/index'

type CardsProps = {
  historier: Array<Historie>,
  range: string
}

export class Stories extends PureComponent<CardsProps> {
  parseRange (range: string) {
    return (range).split('-').map(val => parseInt(val))
  }

  render () {
    const {historier, range} = this.props
    const [start, end] = this.parseRange(range)
    return (
      <div className={styles.stories}>
        {
          historier
            .filter((elem, idx) => idx >= start && idx <= end)
            .map(({value}, idx) => (
              <div key={idx} className={styles.story}>
                <div>
                  {start + idx + 1} av {historier.length}
                </div>

                {value.tekst}
              </div>
            ))
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/stories/index.js